var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLagoutMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.696,
    height: 18,
    viewBox: "0 0 18.696 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160704",
    "data-name": "Group 160704",
    transform: "translate(-413.602 -543)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1347",
    "data-name": "Rectangle 1347",
    width: 18,
    height: 18,
    transform: "translate(414 543)",
    fill: "#ffecd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    cx: 0.481,
    cy: 0.481,
    r: 0.481,
    transform: "translate(422.013 551.536)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M13,7.421V5.751A1.666,1.666,0,0,0,11.343,4.08H3.4A1.66,1.66,0,0,0,1.75,5.751h0V15.774A1.666,1.666,0,0,0,3.4,17.445h7.931a1.666,1.666,0,0,0,1.654-1.671h0V14.1",
    transform: "translate(412.602 541.237)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M18.21,8.04l3.307,3.341L18.21,14.723",
    transform: "translate(410.03 540.619)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_183",
    "data-name": "Line 183",
    x2: 7.476,
    transform: "translate(424.072 552)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_184",
    "data-name": "Line 184",
    x2: 0.658,
    transform: "translate(420.258 552)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLagoutMobileIcon);
export default __webpack_public_path__ + "static/media/lagout-mobile-icon.ed6bc115a7fe98dc7e9989f727ccbc53.svg";
export { ForwardRef as ReactComponent };